import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { actionSet } from './utils'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
  FETCH_DEPOSIT_REQUEST,
  FETCH_DEPOSIT_SUCCESS,
  FETCH_DEPOSIT_ERROR,
} from 'actionTypes'


export const fetch = (token) => async (dispatch) => {
  try {
    dispatch(showSpinner())

    dispatch(actionSet(FETCH_DEPOSIT_REQUEST))

    const response = await new Api(token, dispatch).get(API_URL.FETCH_DEPOSIT)

    return dispatch(actionSet(FETCH_DEPOSIT_SUCCESS, response.data))
  } catch (error) {
    return dispatch(actionSet(FETCH_DEPOSIT_ERROR, error))
  } finally {
    dispatch(hideSpinner())
  }
}
